import useRoutePages from './Pages';

const useRoutes = () => {
   const routes = useRoutePages();
   return routes;
};

export default useRoutes;
